/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/BarcodeDocumentTypes.yaml
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
export const BarcodeDocumentFormatValues = [
    'AAMVA',
    'BOARDING_PASS',
    'DE_MEDICAL_PLAN',
    'MEDICAL_CERTIFICATE',
    'ID_CARD_PDF_417',
    'SEPA',
    'SWISS_QR',
    'VCARD',
    'GS1',
    'HIBC',
];
/**
Barcode document formats.
*/
export class BarcodeDocumentFormats extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeDocumentFormats>`} */
    constructor(source = {}) {
        super();
    }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (BarcodeDocumentFormats) {
    /**
      All barcode document formats.
      */
    BarcodeDocumentFormats.all = [
        'AAMVA',
        'BOARDING_PASS',
        'DE_MEDICAL_PLAN',
        'MEDICAL_CERTIFICATE',
        'ID_CARD_PDF_417',
        'SEPA',
        'SWISS_QR',
        'VCARD',
        'GS1',
        'HIBC',
    ];
    /**
      Barcode types that are used to encode documents.
      */
    BarcodeDocumentFormats.documentBarcodeFormats = {
        AAMVA: ['PDF_417'],
        ID_CARD_PDF_417: ['PDF_417'],
        SEPA: ['QR_CODE'],
        MEDICAL_CERTIFICATE: ['PDF_417'],
        DE_MEDICAL_PLAN: ['DATA_MATRIX'],
        BOARDING_PASS: ['PDF_417', 'AZTEC', 'QR_CODE'],
        VCARD: ['QR_CODE', 'DATA_MATRIX'],
        SWISS_QR: ['QR_CODE'],
        GS1: [
            'CODE_128',
            'AZTEC',
            'DATA_MATRIX',
            'DATABAR',
            'DATABAR_EXPANDED',
            'DATABAR_LIMITED',
            'EAN_13',
            'EAN_8',
            'GS1_COMPOSITE',
            'ITF',
            'MICRO_PDF_417',
            'PDF_417',
            'QR_CODE',
            'UPC_A',
            'UPC_E',
        ],
        HIBC: ['CODE_39', 'CODE_128', 'AZTEC', 'DATA_MATRIX', 'MICRO_PDF_417', 'PDF_417', 'QR_CODE'],
    };
})(BarcodeDocumentFormats || (BarcodeDocumentFormats = {}));
//# sourceMappingURL=BarcodeDocumentTypes.js.map